import React from 'react';
import { Container } from 'theme-ui';
import SEO from '../components/seo';
import PrimaryLayout from '../components/layout/primary/primary';
import { StaticQuery, graphql } from 'gatsby';
import { RichText } from 'prismic-reactjs';
import get from 'lodash/get';

const sellerPageStaticQuery = graphql`
	query {
		prismic {
			allAboutoneons {
				edges {
					node {
					  about_seller
					}
				}
			}
		}
	}
`;

const aboutPage: React.FC<{}> = () => (
	<StaticQuery<GatsbyTypes.Query>
		query={`${sellerPageStaticQuery}`}
		render={(data) => {
			const node = get(data, 'prismic.allAboutoneons.edges[0].node');
			const sellerInfo = node.about_seller;

			return (
				<PrimaryLayout>
					<SEO title="about us" />
					<Container py="40px">
					{RichText.render(sellerInfo)}
					</Container>		
				</PrimaryLayout>

			);
		}}
	/>
);

export default aboutPage;
